'use strict';

angular.module('app').directive('ngEnter', function ($timeout) {
	return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope,elem,attr,ctrl) {
        	elem.bind("keydown", function(ev) {
	            if(ev.which === 13) {
	            	scope.newSearch();
	            }
	        });
        }
    };
});